import axios from "./axiosInstance";
import config from "./config";

const BASE_URL = config.BASE_URL;

const headers = (token: string) => ({
  "Content-Type": "application/json",
  authorization: `Bearer ${token}`,
});

// ============================================================
// SKILL CATEGORIES
// ============================================================

export const getSkillCategories = (token: string, params?: { status?: string }) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/categories`, { headers: headers(token), params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const getSkillCategoryById = (token: string, id: string) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/categories/${id}`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const createSkillCategory = (token: string, data: any) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/categories`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const updateSkillCategory = (token: string, id: string, data: any) => {
  return axios
    .put(`${BASE_URL}/athlete-monitoring/categories/${id}`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const deleteSkillCategory = (token: string, id: string) => {
  return axios
    .delete(`${BASE_URL}/athlete-monitoring/categories/${id}`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

// ============================================================
// SKILLS
// ============================================================

export const getSkills = (token: string, params?: { category_id?: string; status?: string }) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/skills`, { headers: headers(token), params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const createSkill = (token: string, data: any) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/skills`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const updateSkill = (token: string, id: string, data: any) => {
  return axios
    .put(`${BASE_URL}/athlete-monitoring/skills/${id}`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const deleteSkill = (token: string, id: string) => {
  return axios
    .delete(`${BASE_URL}/athlete-monitoring/skills/${id}`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

// ============================================================
// ASSESSMENTS
// ============================================================

export const getAthleteAssessments = (token: string, athleteId: string, params?: { skill_id?: string }) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/assessments`, { headers: headers(token), params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const createAssessment = (token: string, athleteId: string, data: any) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/assessments`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const batchCreateAssessments = (token: string, athleteId: string, assessments: any[]) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/assessments/batch`, { assessments }, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

// ============================================================
// GOALS
// ============================================================

export const getAthleteGoals = (token: string, athleteId: string, params?: { status?: string }) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/goals`, { headers: headers(token), params })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const createGoal = (token: string, athleteId: string, data: any) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/goals`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const updateGoal = (token: string, goalId: string, data: any) => {
  return axios
    .put(`${BASE_URL}/athlete-monitoring/goals/${goalId}`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const deleteGoal = (token: string, goalId: string) => {
  return axios
    .delete(`${BASE_URL}/athlete-monitoring/goals/${goalId}`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const completeGoal = (token: string, goalId: string) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/goals/${goalId}/complete`, {}, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

// ============================================================
// MILESTONES
// ============================================================

export const getAthleteMilestones = (token: string, athleteId: string) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/milestones`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const createMilestone = (token: string, athleteId: string, data: any) => {
  return axios
    .post(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/milestones`, data, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

// ============================================================
// SUMMARY & OVERVIEW
// ============================================================

export const getAthleteSummary = (token: string, athleteId: string) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/athletes/${athleteId}/summary`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};

export const getMonitoringOverview = (token: string) => {
  return axios
    .get(`${BASE_URL}/athlete-monitoring/overview`, { headers: headers(token) })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data);
};
